<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12">
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div v-if="list" class="col-xl-11 col-lg-10 col-md-10 col-sm-9 col-12">
          <h1 class="title-pages mt-1">LISTA: {{ description }}</h1>
          <h6>
            TIPO:
            {{ type == "PRODUCT" ? "PRODUTO" : "MEDICAMENTO" }}
          </h6>
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div v-if="!list">
          <div class="text-center alert alert-warning">
            <h1>LISTA NÃO ENCONTRADA!</h1>
          </div>
        </div>
        <div v-else>
          <ListDetails :id="id" />
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ListDetails from "../templates/List/Details";

import api from "../services/api";

import routes from "../routes";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

import { formatDate } from "../lib/format";

export default {
  name: "List",

  components: {
    NavBar,
    AuthBySessionExpired,
    ListDetails,
  },

  data() {
    return {
      list: null,
      id: "",
      description: "",
      type: "",
      status: 1,
      list_items: [],
      loading: true,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,

    handleToBack: () => routes.go(-1),

    async retrieve() {
      let { id } = routes.currentRoute.params;

      if (!id) {
        return routes.go(-1);
      }

      this.id = id;

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        let { id } = this;

        const params = { id };

        const response = await api.get("/rest-home/list", { params });

        const { error, errors, list, list_items } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          if (list) {
            this.list = list;
            this.description = list.description;
            this.type = list.type;
            this.status = list.status;
            this.list_items = list_items;
            this.updated_at = list.updated_at;
            this.created_at = list.created_at;
          }
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async update(event) {
      try {
        event.preventDefault();

        this.loading = true;

        const { id, description, status } = this;

        let params = {
          id,
          description,
          status,
        };

        const response = await api.put("/rest-home/list", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.errors = [];
          toast(message, "success");
          this.get();
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
